const getConsentStatus = (type: string): boolean => {
  // documentation: https://docs.usercentrics.com/#/frontend-javascript-api
  // v2 documentation: https://docs.usercentrics.com/#/cmp-v2-ui-api?id=getservicesbaseinfo
  // this should work for all envs
  return Boolean(
    window.UC_UI?.getServicesBaseInfo()?.find((service) => service.name === type)?.consent.status ||
      window.usercentrics?.getConsents().find((c) => c.dataProcessor === type)?.consentStatus,
  )
}

export default getConsentStatus
